export const is12HourFormat = () => {
  const date = new Date();
  const locale = navigator.language;

  const options: Intl.DateTimeFormatOptions = { hour: 'numeric' };
  const formattedDate = new Intl.DateTimeFormat(locale, options).format(date);
  return formattedDate.includes('AM') || formattedDate.includes('PM');
};

const TIME_FORMAT_12H = 'M/d/yyyy h:mm:ss a';
const TIME_FORMAT_24H = 'M/d/yyyy H:mm:ss';
const TIME_FORMAT_12H_NO_SECONDS = 'M/d/yyyy h:mm a';
const TIME_FORMAT_24H_NO_SECONDS = 'M/d/yyyy H:mm';

export const DATEPICKER_TIME_FORMAT_NO_SECONDS = is12HourFormat()
  ? TIME_FORMAT_12H_NO_SECONDS
  : TIME_FORMAT_24H_NO_SECONDS;

export const DATEPICKER_TIME_FORMAT = is12HourFormat()
  ? TIME_FORMAT_12H
  : TIME_FORMAT_24H;

export const TIME_US = 'en-US';
export const DATEPICKER_DATE_FORMAT = 'M/d/yyyy';

export const CURRENT_YEAR_M = new Date().getFullYear();
export const MIN_DATE_M = new Date(CURRENT_YEAR_M - 50, 0, 1);
export const MAX_DATE_M = new Date(CURRENT_YEAR_M + 50, 11, 31);
export const MAX_DATE_21_YEARS_AGO = new Date(
  CURRENT_YEAR_M - 21,
  new Date().getMonth(),
  new Date().getDate(),
);
export const DATE_ADAPTER_FORMATS_24H = 'en-GB';
export const DATEPICKER_FORMAT_M = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
